<template>
  <div class="doc">
    <div class="item">
      <img class="img" src="@/assets/activity/activity.png" alt="">
    </div>
    <div class="item">
      <img class="img" src="@/assets/activity/activity01.png" alt="">
      <router-link to="/vipV3/index?headShow=0" class="btn-first"></router-link>
    </div>
    <div class="item">
      <img class="img" src="@/assets/activity/activity02.png" alt="">
      <div @click="goLink" class="btn-first"></div>
    </div>
    <div class="item">
      <img class="img" src="@/assets/activity/activity03.png" alt="">
      <div @click="goPeijia()" class="btn-second"></div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
    name: 'activity',
    methods: {
        goLink () {
            let data = {
                subject: '3',
                version: this.$jsBridge.callBackHandler('getAppVersion')
            }
            Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
            this.$api.getVipMatchEntryExamVideo(data).then(res => {
                Toast.clear()
                if (res.status && res.result) {
                    if (res.result.vipFlag) {
                        this.$jsBridge.callBackHandler('pushExamPlaceRoutePage', { subject: 3 })
                    } else {
                        this.$router.push('/examThreeVideo/index?headShow=0&cityCode=440300')
                    }
                }
            })
        },
        // 跳转陪驾
        goPeijia () {
            // 进入广告内部页面
            this.$jsBridge.callBackHandler('pushAdvertInnerPage', { jumpLink: 'spotDrivComp' })
        }
    }
}
</script>

<style scoped lang="scss">
  .doc{
    line-height: 1;
    font-size: 0;
    .item{
      position: relative;
    }
    .img{
      width: 375px;
    }

    .btn-first{
      position: absolute;
      bottom: 42px;
      height: 55px;
      width: 165px;
      right: 35px;
    }

    .btn-second{
      position: absolute;
      bottom: 50px;
      height: 55px;
      width: 165px;
      right: 35px;
    }
  }

</style>
